<product-form class="col col-120 col-lg-100 col-xl-80"
                [data]="item"
                (submited)="onSubmit($event)">
  <button class="btn btn-success float-right" type="submit">Save</button>
<!--  <a class="btn btn-outline-info float-right ml-2" type="button" (click)="back($event)">Back</a>-->

  <btn-delete form actions type="product"
              [name]="(initial || id)"
              (delete)="delete($event)">
  </btn-delete>
</product-form>
